import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { MenuItem } from 'primeng/components/common/menuitem';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { IDropdownField } from '../dropdown-field-box/model/IDropdown';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
  isMobileView: any = false;
  //add by maaria 
  //inFilteredState: any = false;
  //end
  @Input() items: MenuItem[];
  isFilterShow: boolean;
  isFilterApplyed: boolean;
  searchFieldDetails: any = {
    placeholder: 'Search',
    type: 'text',
    isSearchBox: true
  };

  @Output() gobackbytitle = new EventEmitter<string>();
  @Input() redirectTo: string = '/index2';


  @Input() isDetailsPageShow: boolean = false;
  @Input() totalCount: number;
  @Input() isMoreActionBtn: boolean;
  @Input() title: number;
  @Input() isFilter: boolean;
  //ADDED BY RAHUL
  @Input() IsMapShow: boolean;
  //END
  @Input() listOfFilter: any[] = [];
  @Output() goToTable = new EventEmitter<string>();
  @Output() addBtnClick = new EventEmitter<boolean>();
  @Output() seachValueOutput = new EventEmitter<string>()
  @Output() onFilterClickOutput = new EventEmitter();
  @Output() onFilterClickApplyOutput = new EventEmitter<any[]>();
  @Output() onViewTypeOutput = new EventEmitter<any>();
  @Output() onFilterSearchOutput = new EventEmitter<IDropdownField>();
  @Input() isSearch: boolean = true;
  @Input() isViewTypeBox: boolean = true;
  @Input() isButton: boolean = true;
  @Input() isDropdown: boolean = false;
  @Input() dropdownFieldDetails: any = {};
  @Input() selectedDropdownValue: any;
  selectedLang: any;
  @Input() isShowCount: boolean = true;
  @Input() isBeatshow: boolean = false;
  @Input() isDateField: boolean = false;
  @Input() dateFieldDetails: any = {};
  @Input() selectedDateValue: any;
  @Input() isActionBtn: boolean = false;
  @Input() isFrame: boolean = false;
  @Input() isshareshow: boolean = false;
  @Input() isshowrefresh: boolean = false;
  @Input() isshowoptions: boolean = false;
  @Input() isshowclose: boolean = false;
  @Input() isshowfilter: boolean = false;
  @Input() isshowsearchbar: boolean = false;
  @Input() isAttachment: boolean = false;
  @Input() isattachedfilter: boolean = false;
  @Input() isAttachmentupload: boolean = false;
  @Input() isAttachmentDownload: boolean = false;
  @Input() islatestfilter: boolean = false;
  @Input() isAttachmentdocs: boolean = false;
  @Input() isSearchnewupd: boolean = false;
  @Input() isattachedfilterftl: boolean = false;
  @Input() ispagedownload: boolean = false;
  @Input() isftllisthead: boolean = false;
  @Input() VehicleStatusCount: any = {
    TotalVehicles: 0, RunningVehicles: 0, IdleVehicles: 0, StoppedVehicles: 0, InactiveVehicles: 0, NodataVehicles: 0
  };
  @Input() isReload: boolean = false;
  @Input() isMoreData: boolean = false;
  @Input() isCancel: boolean = false;
  // @Input() isFrame: boolean = false;
  @Input() isBeat: boolean = false;
  @Input() isNewdiscard: boolean = false;
  @Input() isNewTyreDiscard: boolean = false;
  @Input() isNewdiscardReturn: boolean = false;
  @Input() isTyreRepairDrop: boolean = false;
  @Input() IsTyresActionShow: boolean = false;
  @Input() IsDashboardShow: boolean = false;
  @Input() hideBackArrow: boolean = false;
  @Input() IsShipNowDropdown: boolean = false;
  @Output() cancelClicked = new EventEmitter<void>();
  @Input() isSharedBidShow: boolean = false;

  Beat: string = 'Beats';
  TyreRepair: any;
  viewType: string = 'table';
  @Output() onFilterBoxClick = new EventEmitter();
  @Output() onRefreshClick = new EventEmitter<string>();
  isBestUrl: any = environment.apiUrl == 'https://best.ifreightbox.net/' ? true : false;
  checkedValue: any = 'Vehicle';
  @Output() OnCheckRadio = new EventEmitter<string>();
  @Output() onDownloadClickOutput = new EventEmitter();
  ShipNowData: any;

  constructor(
    private mobileDetectionService: MobileDetectionService,
    private translate: TranslateService,
    private service: TranslateConfigService,
    private router: Router
  ) {
    // let language = this.translate.getBrowserLang();
    // let value = localStorage.getItem(LNG_KEY);
    // if (value === "" || value === null || value === undefined) {
    //   this.translate.setDefaultLang(language);
    //   this.selectedLang = language;
    // } else {
    //   this.service.setLanguage(value);
    //   this.selectedLang = value;
    // }
    // let val = localStorage.getItem(LNG_KEY);
  }
  ngOnInit() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    this.intializeform();
  }

  intializeform() {
    this.TyreRepair = {
      formControlName: 'TyreRepair',
      dataField: 'TyreRepair',
      isRequired: false,
      type: "email",
      placeholder: 'All',
    };
    this.ShipNowData = {
      formControlName: 'ShipNowData',
      dataField: 'ShipNowData',
      placeholder: 'select here',
    };
  }

  save(severity: string) {
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  update() {
  }

  delete() {
  }

  onBackArrowCLick() {
    this.goToTable.emit();
  }

  gobackbytitlefn() {
    this.gobackbytitle.emit();
  }

  onAddClick() {
    this.addBtnClick.emit();
  }

  onSearch(value: any) {
    this.seachValueOutput.emit(value);
  }
  onFilterClick(value) {
    this.isFilterShow = value;
    //add by maaria 
    // var filterListContainsData = this.listOfFilter.some(value => value !== '' && value !== undefined && value !== null);
    // filterListContainsData ? this.inFilteredState = true : this.inFilteredState = false;
    //end
    if (value) {
      this.onFilterClickOutput.emit();
    }

  }

  onFilterApply(filterList: any[], isFilterApplyed) {
    this.onFilterClickApplyOutput.emit(filterList);
    this.isFilterApplyed = isFilterApplyed;
  }

  onViewtypeChange(type) {
    this.viewType = type;
    this.onViewTypeOutput.emit(type);
  }

  onFilterSearch = (event: IDropdownField): void => {
    this.onFilterSearchOutput.emit(event);
  }

  onFilterbtnClick(filterType) {
    this.onFilterBoxClick.emit(filterType);
    if (!this.isMobileView) {
      document.getElementById('total').classList.remove('active-total');
      document.getElementById('running').classList.remove('active-running');
      document.getElementById('stopped').classList.remove('active-stopped');
      document.getElementById('inactive').classList.remove('active-inactive');
      document.getElementById('nodata').classList.remove('active-nodata');
      document.getElementById('idle').classList.remove('active-idle');

      if (filterType == 'TotalVehicles') {
        document.getElementById('total').classList.add('active-total');
      } else if (filterType == 'RunningVehicles') {
        document.getElementById('running').classList.add('active-running');
      } else if (filterType == 'StoppedVehicles') {
        document.getElementById('stopped').classList.add('active-stopped');
      } else if (filterType == 'InactiveVehicles') {
        document.getElementById('inactive').classList.add('active-inactive');
      } else if (filterType == 'NodataVehicles') {
        document.getElementById('nodata').classList.add('active-nodata');
      } else if (filterType == 'IdleVehicles') {
        document.getElementById('idle').classList.add('active-idle');
      }
    } else {
      document.getElementById('total1').classList.remove('active-total');
      document.getElementById('running1').classList.remove('active-running');
      document.getElementById('stopped1').classList.remove('active-stopped');
      document.getElementById('inactive1').classList.remove('active-inactive');
      document.getElementById('nodata1').classList.remove('active-nodata');
      document.getElementById('idle1').classList.remove('active-idle');

      if (filterType == 'TotalVehicles') {
        document.getElementById('total1').classList.add('active-total');
      } else if (filterType == 'RunningVehicles') {
        document.getElementById('running1').classList.add('active-running');
      } else if (filterType == 'StoppedVehicles') {
        document.getElementById('stopped1').classList.add('active-stopped');
      } else if (filterType == 'InactiveVehicles') {
        document.getElementById('inactive1').classList.add('active-inactive');
      } else if (filterType == 'NodataVehicles') {
        document.getElementById('nodata1').classList.add('active-nodata');
      } else if (filterType == 'IdleVehicles') {
        document.getElementById('idle1').classList.add('active-idle');
      }
    }
  }

  refreshClick() {
    this.onRefreshClick.emit();
  }

  RadiobtnClick(event) {
    if (event == true)
      this.checkedValue = 'Shipment';
    else
      this.checkedValue = 'Vehicle';
    this.OnCheckRadio.emit(this.checkedValue);
  }

  onDownloadClick() {
    this.onDownloadClickOutput.emit();
  }

  onCancelClick() {
    this.cancelClicked.emit();
  }

  redirectToPage() {
    this.router.navigateByUrl(this.redirectTo);
  }
}
